/**
 *  EndScene
 *
 *  Created by Legman on 16/03/2017.
 *
 */

import Common   from "./Common";

/**
 * @class
 */
export default class IntroScene extends p3.Scene {
    constructor() {
        super();

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._intro1 = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._intro2 = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._intro3 = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._nextButton = null;

        /**
         * @member {Audio}
         * @private
         */
        this._introSFX = null;
    }

    init() {
        super.init();

        const assets = Common.assets;

        const bg = new PIXI.Sprite(assets.getTexture("bg_intro"));
        this.addChild(bg);

        this._intro1 = new PIXI.Sprite(assets.getTexture("intro_top"));
        this._intro1.x = Common.STAGE_WIDTH * 0.5;
        this._intro1.y = Common.STAGE_HEIGHT * 0.5 - this._intro1.texture.height;
        this._intro1.anchor = new PIXI.Point(0.5, 0.5);
        this._intro1.visible = false;
        this.addChild(this._intro1);

        this._intro2 = new PIXI.Sprite(assets.getTexture("intro_mid"));
        this._intro2.x = Common.STAGE_WIDTH * 0.5;
        this._intro2.y = Common.STAGE_HEIGHT * 0.5 - 8;
        this._intro2.anchor = new PIXI.Point(0.5, 0.5);
        this._intro2.visible = false;
        this.addChild(this._intro2);

        this._intro3 = new PIXI.Sprite(assets.getTexture("intro_btm"));
        this._intro3.x = Common.STAGE_WIDTH * 0.5;
        this._intro3.y = Common.STAGE_HEIGHT * 0.5 + this._intro3.texture.height + 12;
        this._intro3.anchor = new PIXI.Point(0.5, 0.5);
        this._intro3.visible = false;
        this.addChild(this._intro3);

        const states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_play_off");

        this._nextButton = new p3.Button(states);
        this._nextButton.visible = false;
        this._nextButton.overSoundName = "sfx_btn_press_00";
        this._nextButton.clickSoundName = "sfx_btn_home_00";
        this._nextButton.signals.click.add(this.onNextButtonClick, this);
        this.addChild(this._nextButton);

        this._introSFX = Common.audio.playSound("sfx_game_play_cpu_intro_00");
    }

    destroy() {
        this._introSFX.stop();

        super.destroy();
    }

    appear() {
        super.appear();
    }

    animateIn() {
        const tl = new TimelineMax();

        const delay = 0.64;

        let to = this._intro1.x;
        this._intro1.x -= p3.View.width;
        tl.append(TweenMax.to(this._intro1, 0.2, {
            x: to,
            ease: Power2.easeOut,
            onStart: function() {
                this._intro1.visible = true;
                Common.audio.playSound("sfx_tv_help_static_00");
            },
            onStartScope: this
        }));

        to = this._intro2.x;
        this._intro2.x += p3.View.width;
        tl.append(TweenMax.to(this._intro2, 0.2, {
            delay: delay,
            x: to,
            ease: Power2.easeOut,
            onStart: function() {
                this._intro2.visible = true;
                Common.audio.playSound("sfx_tv_help_static_00");
            },
            onStartScope: this
        }));

        to = this._intro3.x;
        this._intro3.x -= p3.View.width;
        tl.append(TweenMax.to(this._intro3, 0.2, {
            delay: delay,
            x: to,
            ease: Power2.easeOut,
            onStart: function() {
                this._intro3.visible = true;
                Common.audio.playSound("sfx_tv_help_static_00");
            },
            onStartScope: this
        }));

        // next button
        this._nextButton.scale = new PIXI.Point();
        TweenMax.to(this._nextButton.scale, 0.34, {
            delay: Common.isFirstTime ? 2 : 0.2,
            x: 1.0,
            y: 1.0,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._nextButton.visible = true;
            },
            onStartScope: this
        });
    }

    animateOut() {
    }

    resize() {
        this.y = (p3.View.height - Common.STAGE_HEIGHT) * 0.5;

        this._nextButton.x = p3.View.width - 100;
        this._nextButton.y = (Common.STAGE_HEIGHT + p3.View.height) * 0.5 - 100;
    }

    update() {
    }

    /**
     * @param {p3.Button} button
     */
    onNextButtonClick(button) {
        this.signals.next.dispatch(this);
    }
}
